import React from "react";
import EmptyState from "../common/EmptyState";
import "./TrackYourGovernment.scss";

// Is component ka apna spinner — CSS animation TrackYourGovernment.scss me hai
const GovtLoader = ({ label }) => (
  <div className="govt-loader" role="status" aria-live="polite">
    <span className="govt-spinner" aria-hidden="true"></span>
    <span>{label}</span>
  </div>
);

const TrackYourGovernment = ({
  govtView,
  setGovtView,
  govtUpdates,
  govtUpdatesLoading,
  govtMinisters,
  govtMinistersLoading,
  govtOpen,
  toggleGovtSummary,
}) => {
  const govtPM = govtMinisters.length > 0 ? govtMinisters[0] : null;
  const govtRestMinisters = govtMinisters.length > 1 ? govtMinisters.slice(1) : [];

  const getMinisterInitials = (name) => {
    if (!name) return "";
    const parts = name.trim().split(/\s+/);
    const first = parts[0]?.[0] || "";
    const last = parts.length > 1 ? parts[parts.length - 1]?.[0] : "";
    return (first + last).toUpperCase();
  };

  // Ek hi loader: Domestic view me updates + ministers dono ka wait,
  // Foreign view me sirf updates ka.
  const isLoading =
    govtView === "exec"
      ? govtUpdatesLoading || govtMinistersLoading
      : govtUpdatesLoading;

  const loaderLabel =
    govtView === "exec" ? "Loading updates & ministers…" : "Loading updates…";

  return (
    <div className="govt-container">
      <div className="pub-section-lbl" style={{ color: "#12308c", fontWeight: 700, paddingTop: 16 }}>
        <i className="ti ti-building-bank"></i> Track Your Government
      </div>
      <div className="govt-card">
        <p className="ctf-intro">
          What the government actually did this week, and what has Parliament actually done with its time — in plain language, sourced from the government's own published records.
        </p>
        <div className="simple-seg">
          <button className={`simple-seg-btn${govtView === "exec" ? " on" : ""}`} onClick={() => setGovtView("exec")}>
            🏛️ Domestic Affairs 
          </button>
          <button className={`simple-seg-btn${govtView === "parl" ? " on" : ""}`} onClick={() => setGovtView("parl")}>
            🌐︎ Foreign Affairs
          </button>
        </div>
        <div className="govt-result">
          {govtView === "exec" && (
            <>
              <div className="govt-section-lbl">Domestic Affairs — this week's decisions, explained simply</div>

              {isLoading && <GovtLoader label={loaderLabel} />}

              {!isLoading && govtUpdates.length === 0 && <EmptyState label="No updates found." />}
              {!isLoading && govtUpdates.map((u) => (
                <div className="govt-bill-card" key={u.id}>
                  <div className="govt-bill-top">
                    <div className="govt-bill-name">{u.title}</div>
                    {u.tag && <span className={`govt-bill-status ${u.tag === 'APPROVED' ? 'gbs-passed' : u.tag === 'PENDING' ? 'gbs-pending' : 'gbs-lapsed'}`}>{u.tag}</span>}
                  </div>
                  <div className="govt-bill-summary">{u.description}</div>
                  {u.summary && (
                    <>
                      <button className="govt-summary-btn" onClick={() => toggleGovtSummary(`gu-${u.id}`)}>
                        <i className="ti ti-list-check"></i> Summary
                      </button>
                      <div className={`govt-oneliner${govtOpen[`gu-${u.id}`] ? " open" : ""}`}>
                        {u.summary}
                      </div>
                    </>
                  )}
                  {u.elsewhere_in_world && (
                    <div className="govt-compare-box">
                      <b>Elsewhere in the world:</b> {u.elsewhere_in_world}
                    </div>
                  )}
                </div>
              ))}

              {!isLoading && govtPM && (
                <div className="govt-pm-card">
                  <div className="govt-pm-av">{getMinisterInitials(govtPM.MinisterName)}</div>
                  <div className="govt-pm-txt">
                    <b>{govtPM.MinisterName}</b>
                    <span>{govtPM.Portfolio}</span>
                  </div>
                </div>
              )}
              {!isLoading && govtMinisters.length > 0 && (
                <>
                  <div className="govt-section-lbl">Who's Running the Government</div>
                  <table className="govt-min-table">
                    <thead><tr><th>Minister</th><th>Portfolio</th></tr></thead>
                    <tbody>
                      {govtRestMinisters.map((m) => (
                        <tr key={m.id}>
                          <td data-label="Minister">{m.MinisterName}</td>
                          <td data-label="Portfolio">{m.Portfolio}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </>
              )}
              {!isLoading && govtMinisters.length === 0 && <EmptyState label="No ministers data available." />}
            </>
          )}
          {govtView === "parl" && (
            <>
              <div className="govt-section-lbl">Foreign Affairs — where India stands, in plain language</div>

              {isLoading && <GovtLoader label={loaderLabel} />}

              {!isLoading && govtUpdates.length === 0 && <EmptyState label="No updates found." />}
              {!isLoading && govtUpdates.map((u) => (
                <div className="govt-bill-card" key={u.id}>
                  <div className="govt-bill-top">
                    <div className="govt-bill-name">{u.title}</div>
                    {u.tag && <span className="govt-bill-status gbs-passed">{u.tag}</span>}
                  </div>
                  <div className="govt-bill-summary">{u.description}</div>
                  {u.summary && (
                    <>
                      <button className="govt-summary-btn" onClick={() => toggleGovtSummary(`gu-${u.id}`)}>
                        <i className="ti ti-list-check"></i> Summary
                      </button>
                      <div className={`govt-oneliner${govtOpen[`gu-${u.id}`] ? " open" : ""}`}>
                        {u.summary}
                      </div>
                    </>
                  )}
                  {u.elsewhere_in_world && (
                    <div className="govt-compare-box">
                      <b>Elsewhere in the world:</b> {u.elsewhere_in_world}
                    </div>
                  )}
                </div>
              ))}
            </>
          )}
        </div>
        <div className="ec-src">
          Sources: Cabinet decisions and Parliament updates as published by the government; Council of Ministers list sourced live from the ministers directory.
        </div>
      </div>
    </div>
  );
};

export default TrackYourGovernment;